(() => {
  const KEY = 'terracotta-wishlist';
  const read = () => {
    try { return new Set(JSON.parse(localStorage.getItem(KEY) || '[]').map(String)); }
    catch { return new Set(); }
  };
  const write = (set) => localStorage.setItem(KEY, JSON.stringify([...set]));

  const sync = () => {
    const saved = read();
    document.querySelectorAll('[data-tc-wishlist]').forEach((button) => {
      const active = saved.has(String(button.dataset.tcWishlist));
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      const title = button.getAttribute('aria-label') || '';
      if (active && title.startsWith('Adicionar')) {
        button.setAttribute('aria-label', title.replace('Adicionar', 'Remover').replace(' aos favoritos', ' dos favoritos'));
      }
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-tc-wishlist]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    const saved = read();
    const id = String(button.dataset.tcWishlist);
    if (saved.has(id)) saved.delete(id); else saved.add(id);
    write(saved);
    sync();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
  document.addEventListener('shopify:section:load', sync);
})();